import {FC} from 'react';
import {TermsGerman} from '../../components/termsAndPolicy/TermsGerman';

export const TermsOfUseDe: FC = () => {
    return <TermsGerman/>;
};
